"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Thiana API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfGenerationOutput = instanceOfGenerationOutput;
exports.GenerationOutputFromJSON = GenerationOutputFromJSON;
exports.GenerationOutputFromJSONTyped = GenerationOutputFromJSONTyped;
exports.GenerationOutputToJSON = GenerationOutputToJSON;
/**
 * Check if a given object implements the GenerationOutput interface.
 */
function instanceOfGenerationOutput(value) {
    if (!('generation' in value) || value['generation'] === undefined)
        return false;
    return true;
}
function GenerationOutputFromJSON(json) {
    return GenerationOutputFromJSONTyped(json, false);
}
function GenerationOutputFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'generation': json['generation'],
    };
}
function GenerationOutputToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'generation': value['generation'],
    };
}
